import React from 'react';
import SignUpLayout from 'components/auth/components/SignUpLayout';
import boatsetterPaths from 'utils/boatsetterPaths';
import AuthSteps from 'components/auth/components/AuthSteps';
import conditionalRedirect from 'utils/conditionalRedirect';
import { initFirebase } from 'stacks/messaging/Firebase';
import getConfig from 'next/config';

// This is the single Clerk log in and sign up page. We redirect to the non-Clerk login page for auth IF we are
// bypassing Clerk.

initFirebase();

const { BYPASS_CLERK } = getConfig().publicRuntimeConfig;

// @TODO remove loading guard after legacy login is removed
export const getServerSideProps = conditionalRedirect({
  destination: boatsetterPaths.logIn,
  shouldRedirect: BYPASS_CLERK,
});

const Auth = () => (
  <SignUpLayout>
    <AuthSteps />
  </SignUpLayout>
);

export default Auth;
